/*
 * bdm-free-shipping.js
 * ---------------------------------------------------------------------------
 * Borie de Maurel — barre « livraison offerte » dans le panier (page panier +
 * tiroir panier), ajoutée le 02/11/2026. Textes FR / EN / NL selon
 * window.bdmLang (posé par snippets/bdm-free-shipping.liquid).
 *
 * Seuils (doivent rester alignés sur Paramètres → Expédition et livraison) :
 *   - France et Monaco : 10 €, offerte dès 150 €
 *   - Europe (AT, BE, DE, ES, IT, LU, NL, PT) : 25 €, offerte dès 250 €
 * Le pays vient de localization.country (window.bdmShipCountry, posé par
 * snippets/bdm-free-shipping.liquid). Pays hors liste : pas de barre.
 *
 * Même principe que bdm-cart-multiple.js : le thème remplace le DOM du panier
 * à chaque changement de quantité, donc on relit /cart.js et on réinsère la
 * barre après chaque mutation (MutationObserver), sans rien réécrire si rien
 * n'a changé (évite les boucles avec bdm-cart-multiple.js).
 */
(function () {
  'use strict';

  var THRESHOLDS = {
    FR: 15000, MC: 15000,
    AT: 25000, BE: 25000, DE: 25000, ES: 25000,
    IT: 25000, LU: 25000, NL: 25000, PT: 25000
  };
  var COUNTRY = (window.bdmShipCountry || 'FR').toUpperCase();
  var THRESHOLD = THRESHOLDS[COUNTRY];
  if (!THRESHOLD) return;

  var LANG = String(window.bdmLang || 'fr').slice(0, 2).toLowerCase();
  var TEXTS = {
    fr: { locale: 'fr-FR', done: 'La livraison vous est offerte.', before: 'Plus que ', after: ' et la livraison vous est offerte.' },
    en: { locale: 'en-GB', done: 'Delivery is free.', before: 'Just ', after: ' more and delivery is free.' },
    nl: { locale: 'nl-NL', done: 'De levering is gratis.', before: 'Nog ', after: ' en de levering is gratis.' }
  };
  var T = TEXTS[LANG] || TEXTS.fr;

  var BTN_SELECTOR = '.cart__checkout-button, #checkout, button[name="checkout"]';
  var observer = null;
  var lastTotal = null;

  function money(cents) {
    var whole = cents % 100 === 0;
    return new Intl.NumberFormat(T.locale, {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: whole ? 0 : 2,
      maximumFractionDigits: whole ? 0 : 2
    }).format(cents / 100);
  }

  function messageFor(total) {
    if (total >= THRESHOLD) return T.done;
    return T.before + money(THRESHOLD - total) + T.after;
  }

  function sync(total) {
    lastTotal = total;
    var buttons = document.querySelectorAll(BTN_SELECTOR);
    if (!buttons.length) return;

    if (observer) observer.disconnect();

    buttons.forEach(function (btn) {
      var container = btn.closest('.cart__ctas') || btn.parentNode;
      if (!container) return;
      var bar = container.querySelector('.bdm-shipping');

      if (total <= 0) {
        if (bar) bar.parentNode.removeChild(bar);
        return;
      }

      var reached = total >= THRESHOLD;
      var pct = Math.min(100, Math.round((total / THRESHOLD) * 100)) + '%';
      var text = messageFor(total);

      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'bdm-shipping';
        bar.setAttribute('role', 'status');
        bar.innerHTML =
          '<p class="bdm-shipping__text"></p>' +
          '<div class="bdm-shipping__track" aria-hidden="true"><span class="bdm-shipping__fill"></span></div>';
        container.insertBefore(bar, container.firstChild);
      }

      var p = bar.querySelector('.bdm-shipping__text');
      var fill = bar.querySelector('.bdm-shipping__fill');
      if (p.textContent !== text) p.textContent = text;
      if (fill.style.width !== pct) fill.style.width = pct;
      if (bar.classList.contains('bdm-shipping--reached') !== reached) {
        bar.classList.toggle('bdm-shipping--reached', reached);
      }
    });

    if (observer) reconnect();
  }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { sync(cart.item_count > 0 ? (cart.total_price || 0) : 0); })
      .catch(function () {});
  }

  var timer = null;
  function scheduleRefresh() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 150);
  }

  function reconnect() {
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    observer = new MutationObserver(function () {
      if (!document.querySelector(BTN_SELECTOR)) return;
      // Barre absente d'un panier non vide (DOM remplacé) : on la remet tout de suite.
      var missing = lastTotal > 0 && !document.querySelector('.cart__ctas .bdm-shipping');
      if (missing) sync(lastTotal);
      scheduleRefresh();
    });
    reconnect();
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) scheduleRefresh();
  });
})();
